<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import { TypographyWithPrefix } from '@/components/Typography'
import type { DeviceModel } from '@/types/models/DeviceModel'
import type { AlertSocketMessageModel } from '@/types/socket/SocketAlertModel'

type Props = {
    data: Partial<DeviceModel>
    status?: AlertSocketMessageModel
}
defineProps<Props>()
</script>

<template>
    <StackLayout direction="column" :gap="8">
        <slot />
        <TypographyWithPrefix
            :prefix="$t('device.model.deviceType')"
            :label="data?.device_type_name"
            boldLabel />
        <TypographyWithPrefix
            :prefix="$t('device.model.serialNumber')"
            :label="data?.serial_number"
            boldLabel />
        <TypographyWithPrefix
            :prefix="$t('device.model.firmwareVersion')"
            :label="status?.version ?? data?.version"
            boldLabel />
        <TypographyWithPrefix
            v-if="data?.sim_iccid"
            :prefix="$t('device.model.simIccid')"
            :label="data?.sim_iccid"
            boldLabel />
    </StackLayout>
</template>
